const initialState = {

    // TODO: Move this to time related reducer later
    currentTime: 1505475887000, // Friday, September 15, 2017 11:44:47 AM
    currentDate: 1505475887000, // Friday, September 15, 2017 11:44:47 AM

    // User portfolio
    portfolio: {
        /*
        portfolio: 10861682,
        todayGain: -53386,
        todayGainPercentage: -0.599642754774867,
        overallGain: 4864215,
        overallGainPercentage: 81.10448961203122,
        */
    },

    companyPortfolio: {
        /*
        NABIL: {
            avgCost: 1003.270914225203,
            daysGain: -33996,
            daysGainPercent: -0.7792207792207793,
            lastPrice: 764,
            mktValue: 4328824,
            overallGain: -1355709,
            overallGainPercent: -23.84908311729389,
            proceedFromSell: 2356,
            ticker: 'CHCL',
            timestamp: 1504770570000,
            totalShares: 5666,
            wellOffBy: -20635.46545965899,
        },
        */
    },

    equityActiveTicker: undefined,

    equityDividendHistory: {
        /*
        NABIL: [
            {
                year: '2015/16',
                bonus: 0.3333,
                cash: 0.0175,
            },
            {
                year: '2015/14',
                bonus: 0.25,
                cash: 0.1921,
            },
            {
                year: '2015/15',
                bonus: 0.1,
                cash: 0.4,
            },
            {
                year: '2015/17',
                bonus: 0.3333,
                cash: 0.0175,
            },
            {
                year: '2015/18',
                bonus: 0.25,
                cash: 0.1921,
            },
            {
                year: '2015/19',
                bonus: 0.1,
                cash: 0.4,
            },
            {
                year: '2015/20',
                bonus: 0.3333,
                cash: 0.0175,
            },
            {
                year: '2015/21',
                bonus: 0.25,
                cash: 0.1921,
            },
            {
                year: '2015/22',
                bonus: 0.1,
                cash: 0.4,
            },
            {
                year: '2015/23',
                bonus: 0.3333,
                cash: 0.0175,
            },
            {
                year: '2015/24',
                bonus: 0.25,
                cash: 0.1921,
            },
            {
                year: '2015/25',
                bonus: 0.1,
                cash: 0.4,
            },
        ],
        */
    },

    equityAnnouncements: {
        /*
        NABIL: [
            {
                id: 1,
                details: 'Nulla facilisi.....',
                inputDate: 1501867165010,
            },
            {
                id: 2,
                details: 'Lorem ipsum dolor...',
                inputDate: 15010478345100,
            },
            {
                id: 3,
                details: 'Lorem Ipsum sit Dolor Amet',
                inputDate: 153455165001,
            },
            {
                id: 4,
                details: 'Suspendisse lobortis ....',
                inputDate: 150125162200,
            },
        ],
        */
    },

    equityKeyFinancials: {
        /*
        NABIL: [
            {
                year: '2016/17',
                quarter: 4,
                totalRevenue: 8065591,
                growthOverPriorPeriod: 0.3987,
                grossProfit: 5459500,
                grossProfitMargin: 0.6769,
                netIncome: 3620821,
                netIncomeMargin: 0.4489,
                epsAnnualized: 58.5372,
                bookValuePerShare: 245.9919,
                returnOnAsset: 0.0262,
                returnOnEquity: 0.2681,
            },
            {
                year: '2016/17',
                quarter: 3,
                totalRevenue: 5718067,
                growthOverPriorPeriod: 0.4328,
                grossProfit: 4081821,
                grossProfitMargin: 0.7138,
                netIncome: 2683740,
                netIncomeMargin: 0.4693,
                epsAnnualized: 57.8501,
                bookValuePerShare: 230.8423,
                returnOnAsset: 0.0251,
                returnOnEquity: 0.2704,
            },
            {
                year: '2016/17',
                quarter: 2,
                totalRevenue: 3575465,
                growthOverPriorPeriod: 0.2479,
                grossProfit: 2665478,
                grossProfitMargin: 0.7455,
                netIncome: 1747944,
                netIncomeMargin: 0.4889,
                epsAnnualized: 56.5354,
                bookValuePerShare: 215.7502,
                returnOnAsset: 0.0239,
                returnOnEquity: 0.2663,
            },
            {
                year: '2016/17',
                quarter: 1,
                totalRevenue: 1722629,
                growthOverPriorPeriod: 0.1505,
                grossProfit: 1270360,
                grossProfitMargin: 0.7375,
                netIncome: 798368,
                netIncomeMargin: 0.4635,
                epsAnnualized: 51.6447,
                bookValuePerShare: 200.3937,
                returnOnAsset: 0.0226,
                returnOnEquity: 0.2592,
            },
            {
                year: '2015/16',
                quarter: 4,
                totalRevenue: 6155660,
                growthOverPriorPeriod: 0.1308,
                grossProfit: 4325971,
                grossProfitMargin: 0.7028,
                netIncome: 2821564,
                netIncomeMargin: 0.4584,
                epsAnnualized: 59.3193,
                bookValuePerShare: 258.7742,
                returnOnAsset: 0.0223,
                returnOnEquity: 0.2586,
            },
        ],
        */
    },

    equityTearsheet: {
        /*
        SIGS1: {
            dataType: 'mutualFund',
            data: {
                wtAvgPrice: 21.1824,
                sharesTraded: 8500,
                volume: 180050,
                mktCap: 1057500,
                percentageChange: {
                    oneWeek: 0.0028,
                    oneMonth: -0.0204,
                    threeMonth: -0.1264,
                    oneYear: 0.0558,
                },
                fundInfo: {
                    aum: 1063119.929,
                    weeklyNav: 21.15,
                    monthlyNav: 21.0753,
                    discountToNav: 0,
                    fundBeta: 0.652,
                    monthVarAt1: -11.051,
                    cagr: 0.1615,
                },
                assetAllocation: {
                    equity: 0.652,
                    fixedIncome: 0.334,
                    cash: 0.1069,
                },
                schemeInfo: {
                    scheme: 'Closed End',
                    objective: 'Balanced Growth',
                    maturity: '5 years',
                    baseSize: '500 Million',
                    daysHighLow: {
                        high: 21.2,
                        low: 21.15,
                        percentile: 27.1605,
                    },
                    fiftyTwoWeekHighLow: {
                        high: 28.65,
                        low: 19,
                        percentile: 0.8103,
                    },
                },
                liquidityIndicator: {
                    daysTradedStockvsNepse: 0.4348,
                    avgVol: 12001,
                    avgNoOfTrades: 3.2,
                    avgSharesPerTrade: 3956.8095,
                },
                equity: [
                    {
                        ticker: 'NLG',
                        portWeight: 0.0762,
                    },
                    {
                        ticker: 'EBL',
                        portWeight: 0.0646,
                    },
                    {
                        ticker: 'SIC',
                        portWeight: 0.0642,
                    },
                    {
                        ticker: 'SKBBL',
                        portWeight: 0.0549,
                    },
                    {
                        ticker: 'NABILP',
                        portWeight: 0.0546,
                    },
                    {
                        ticker: 'NLICL',
                        portWeight: 0.0485,
                    },
                    {
                        ticker: 'UNL',
                        portWeight: 0.0436,
                    },
                    {
                        ticker: 'PRIN',
                        portWeight: 0.0348,
                    },
                    {
                        ticker: 'LICN',
                        portWeight: 0.0331,
                    },
                    {
                        ticker: 'SWBBL',
                        portWeight: 0.0327,
                    },
                ],
                sector: [
                    {
                        label: 'TEL',
                        value: 0.0001,
                    },
                    {
                        label: 'MNP',
                        value: 0.0436,
                    },
                    {
                        label: 'HP',
                        value: 0.037599999999999995,
                    },
                    {
                        label: 'NLI',
                        value: 0.2346,
                    },
                    {
                        label: 'HOT',
                        value: 0.0056,
                    },
                    {
                        label: 'CB',
                        value: 0.3209,
                    },
                    {
                        label: 'MC',
                        value: 0.1903,
                    },
                    {
                        label: 'LI',
                        value: 0.1463,
                    },
                    {
                        label: 'DB',
                        value: 0.021100000000000004,
                    },
                ],
                announcement: [
                    {
                        id: 2671,
                        ticker: 'SIGS1',
                        companyName: 'Siddhartha Investment Growth Scheme-1',
                        inputDate: 1505153700000,
                        fiscalYear: 'FY 2016/17',
                        detail: 'Cash Dividend Distribution',
                        agenda: '60% Cash Dividend Distribution',
                        openDate: 1505240100000,
                        announcementType: 'Distribution',
                        shareRegistrar: 'Siddhartha Capital Ltd.',
                    },
                    {
                        id: 6363,
                        ticker: 'SIGS1',
                        companyName: 'Siddhartha Investment Growth Scheme-1',
                        inputDate: 1506363300000,
                        eventDate: 1506363300000,
                        fiscalYear: 'FY 2017/18',
                        detail: 'Monthly Financial Report- Bhadra 2074',
                        announcementType: 'Financials',
                    },
                    {
                        id: 6483,
                        ticker: 'SIGS1',
                        companyName: 'Siddhartha Investment Growth Scheme-1',
                        inputDate: 1509473700000,
                        eventDate: 1509473700000,
                        fiscalYear: 'FY 2017/18',
                        detail: 'Monthly Financial Report -Ashwin 2074',
                        announcementType: 'Financials',
                    },
                    {
                        id: 6738,
                        ticker: 'SIGS1',
                        companyName: 'Siddhartha Investment Growth Scheme-1',
                        inputDate: 1511633700000,
                        eventDate: 1511633700000,
                        fiscalYear: 'FY 2017/18',
                        detail: 'Monthly Financial Report -Kartik 2074',
                        announcementType: 'Financials',
                    },
                ],
                percentageChangeChart: {
                    oneMonth: {
                        price: 0.0379,
                        nav: -0.00797373358348976,
                        bechmark: -1.9893717172110659,
                    },
                    threeMonth: {
                        price: 0.122,
                        nav: -0.2437786041189932,
                        bechmark: -1.9533897244675793,
                    },
                    oneYear: {
                        price: 0.0487,
                        nav: -0.19151376146788995,
                        bechmark: -1.980661685683212,
                    },
                },
            },
        },
        NABIL: {
            dataType: 'tearsheet',
            data: {
                wtAvgPrice: 2026.13,
                sharesTraded: 4679,
                volume: 9480260,
                mktCap: 80995563366,
                percentageChange: {
                    oneWeek: 0.0186,
                    oneMonth: -0.0725,
                    threeMonth: -0.1151,
                    oneYear: -0.1422,
                },
                stockInfo: {
                    reportedPaidup: 40057.15,
                    listedShares: 40057153,
                    oneEightyAvg: 2218.7768,
                    betaMonthly: 1.1979,
                    betaWeekly: 1.1489,
                    varOneWeekFivePercent: -0.0155,
                    varOneWeekOnePercent: -0.0222,
                    varOneMonthFivePercent: -0.1295,
                    varOneMonthOnePercent: -0.1904,
                },
                keyStatVsIndustry: {
                    eps: {
                        value: 48.184,
                        high: 48.3084,
                        low: 3.7072,
                        percentile: 98.0392,
                    },
                    pe: {
                        value: 41.9642,
                        high: 64.6207,
                        low: 7.2451,
                        percentile: 93.8776,
                    },
                    pb: {
                        value: 6.45,
                        high: 6.45,
                        low: 0.9786,
                        percentile: 100,
                    },
                    roe: {
                        value: 0.1561,
                        high: 0.319,
                        low: 0.0293,
                        percentile: 78.4314,
                    },
                    roa: {
                        value: 0.0236,
                        high: 0.0332,
                        low: 0.0042,
                        percentile: 98.0392,
                    },
                    daysHighLow: {
                        high: 2050,
                        low: 2021,
                        percentile: 21.3793,
                    },
                    fiftyTwoWeekHighLow: {
                        high: 3110,
                        low: 1754,
                        percentile: 23.4783,
                    },
                },
                liquidityIndicator: {
                    daysTraded: 1,
                    avgVolume: 7882.9091,
                    avgNoOfTrades: 146,
                    avgSharesPerTrade: 53.1467,
                },
                changeSinceLastQuater: {
                    changeInProfitability: 48.184,
                    changeInSentiment: 41.9642,
                },
                technicalIndicators: {
                    relativeStrength: -0.03153487883711559,
                    fiftyDMaVs200d: -0.0175,
                    priceVs52WkHigh: -0.1458,
                    rsi: 37.1221,
                    macd: -36.657,
                },
            },
        },
       */
    },

    equityTimeSeries: {
        /*
        NABIL: {
            '5y': [
                { value: 430.1129, timeStamp: 1354731300000 },
                { value: 427.8159, timeStamp: 1355336100000 },
                { value: 446.7661, timeStamp: 1355940900000 },
                { value: 488.3992, timeStamp: 1356545700000 },
                { value: 480.934, timeStamp: 1357409700000 },
                { value: 473.7559, timeStamp: 1358014500000 },
                { value: 445.0434, timeStamp: 1358619300000 },
                { value: 460.8352, timeStamp: 1359224100000 },
                { value: 465.1421, timeStamp: 1359828900000 },
                { value: 475.1915, timeStamp: 1360433700000 },
                { value: 542.6658, timeStamp: 1361038500000 },
                { value: 541.2302, timeStamp: 1361729700000 },
                { value: 539.7946, timeStamp: 1362334500000 },
                { value: 545.5371, timeStamp: 1362939300000 },
                { value: 539.7946, timeStamp: 1363544100000 },
                { value: 531.7551, timeStamp: 1364148900000 },
                { value: 525.4383, timeStamp: 1364840100000 },
                { value: 531.1808, timeStamp: 1365444900000 },
                { value: 525.4383, timeStamp: 1366049700000 },
                { value: 517.9731, timeStamp: 1366654500000 },
                { value: 508.2108, timeStamp: 1367259300000 },
                { value: 489.2606, timeStamp: 1367864100000 },
                { value: 485.2409, timeStamp: 1368468900000 },
                { value: 502.4683, timeStamp: 1369073700000 },
                { value: 505.6267, timeStamp: 1369678500000 },
                { value: 502.4683, timeStamp: 1370283300000 },
                { value: 503.0426, timeStamp: 1370888100000 },
                { value: 493.5675, timeStamp: 1371492900000 },
                { value: 496.7258, timeStamp: 1372097700000 },
                { value: 501.8941, timeStamp: 1372702500000 },
                { value: 510.795, timeStamp: 1373307300000 },
                { value: 516.8246, timeStamp: 1373912100000 },
                { value: 551.2796, timeStamp: 1374516900000 },
                { value: 548.4083, timeStamp: 1375121700000 },
                { value: 546.3984, timeStamp: 1375726500000 },
                { value: 525.4383, timeStamp: 1376331300000 },
                { value: 532.6164, timeStamp: 1376936100000 },
                { value: 526.5868, timeStamp: 1377713700000 },
                { value: 522.5671, timeStamp: 1378318500000 },
                { value: 564.2002, timeStamp: 1378923300000 },
                { value: 568.507, timeStamp: 1379528100000 },
                { value: 571.3783, timeStamp: 1380132900000 },
                { value: 567.3585, timeStamp: 1380737700000 },
                { value: 582.8633, timeStamp: 1381342500000 },
                { value: 592.9126, timeStamp: 1381947300000 },
                { value: 620.1895, timeStamp: 1382552100000 },
                { value: 631.1002, timeStamp: 1383156900000 },
                { value: 624.4964, timeStamp: 1383761700000 },
                { value: 640.0011, timeStamp: 1384366500000 },
                { value: 724.4158, timeStamp: 1385230500000 },
                { value: 710.3467, timeStamp: 1385835300000 },
                { value: 789.5931, timeStamp: 1386440100000 },
                { value: 837.4907, timeStamp: 1387044900000 },
                { value: 858.2459, timeStamp: 1387649700000 },
                { value: 819.2844, timeStamp: 1388254500000 },
                { value: 768.3067, timeStamp: 1388945700000 },
                { value: 819.2844, timeStamp: 1389550500000 },
                { value: 795.6162, timeStamp: 1390155300000 },
                { value: 755.5623, timeStamp: 1390760100000 },
                { value: 731.53, timeStamp: 1391364900000 },
                { value: 784.6924, timeStamp: 1391969700000 },
                { value: 760.2959, timeStamp: 1392574500000 },
                { value: 776.6816, timeStamp: 1393179300000 },
                { value: 751.921, timeStamp: 1393784100000 },
                { value: 720.9703, timeStamp: 1394388900000 },
                { value: 675.4545, timeStamp: 1394993700000 },
                { value: 697.3021, timeStamp: 1395598500000 },
                { value: 690.0195, timeStamp: 1396203300000 },
                { value: 708.2259, timeStamp: 1396808100000 },
                { value: 726.4322, timeStamp: 1397499300000 },
                { value: 702.764, timeStamp: 1398104100000 },
                { value: 695.4814, timeStamp: 1398708900000 },
                { value: 739.1766, timeStamp: 1399313700000 },
                { value: 728.2528, timeStamp: 1399918500000 },
                { value: 697.3021, timeStamp: 1400609700000 },
                { value: 722.7909, timeStamp: 1401214500000 },
                { value: 747.1874, timeStamp: 1401905700000 },
                { value: 786.513, timeStamp: 1402510500000 },
                { value: 826.5669, timeStamp: 1403115300000 },
                { value: 837.8549, timeStamp: 1403720100000 },
                { value: 859.3383, timeStamp: 1404324900000 },
                { value: 910.316, timeStamp: 1404929700000 },
                { value: 920.5116, timeStamp: 1405534500000 },
                { value: 965.6632, timeStamp: 1406139300000 },
                { value: 936.169, timeStamp: 1406744100000 },
                { value: 900.1205, timeStamp: 1407348900000 },
                { value: 912.1367, timeStamp: 1408299300000 },
                { value: 859.3383, timeStamp: 1408904100000 },
                { value: 874.6316, timeStamp: 1409508900000 },
                { value: 861.159, timeStamp: 1410200100000 },
                { value: 846.5939, timeStamp: 1410804900000 },
                { value: 805.8117, timeStamp: 1411409700000 },
                { value: 872.0827, timeStamp: 1412014500000 },
                { value: 827.2952, timeStamp: 1413137700000 },
                { value: 844.7733, timeStamp: 1413742500000 },
                { value: 860.7948, timeStamp: 1414347300000 },
                { value: 801.0781, timeStamp: 1414952100000 },
                { value: 801.0781, timeStamp: 1415556900000 },
                { value: 729.2311, timeStamp: 1416161700000 },
                { value: 764.9121, timeStamp: 1416766500000 },
                { value: 754.6538, timeStamp: 1417371300000 },
                { value: 761.344, timeStamp: 1417976100000 },
                { value: 869.7252, timeStamp: 1418580900000 },
                { value: 818.8797, timeStamp: 1419185700000 },
                { value: 835.3822, timeStamp: 1419790500000 },
                { value: 826.0159, timeStamp: 1420481700000 },
                { value: 842.9644, timeStamp: 1421086500000 },
                { value: 869.7252, timeStamp: 1421691300000 },
                { value: 900.9461, timeStamp: 1422382500000 },
                { value: 896.4859, timeStamp: 1422987300000 },
                { value: 891.1338, timeStamp: 1423592100000 },
                { value: 885.3356, timeStamp: 1424196900000 },
                { value: 870.6172, timeStamp: 1424801700000 },
                { value: 865.265, timeStamp: 1425406500000 },
                { value: 867.4951, timeStamp: 1426097700000 },
                { value: 858.5748, timeStamp: 1426702500000 },
                { value: 834.0441, timeStamp: 1427307300000 },
                { value: 842.5184, timeStamp: 1427912100000 },
                { value: 849.6546, timeStamp: 1428516900000 },
                { value: 869.7252, timeStamp: 1429121700000 },
                { value: 848.3165, timeStamp: 1429726500000 },
                { value: 714.5127, timeStamp: 1432750500000 },
                { value: 847.4245, timeStamp: 1433355300000 },
                { value: 865.265, timeStamp: 1433960100000 },
                { value: 838.5043, timeStamp: 1434564900000 },
                { value: 840.7343, timeStamp: 1435169700000 },
                { value: 851.4386, timeStamp: 1435774500000 },
                { value: 856.3448, timeStamp: 1436379300000 },
                { value: 851.8846, timeStamp: 1436984100000 },
                { value: 896.4859, timeStamp: 1437588900000 },
                { value: 1025.8297, timeStamp: 1438193700000 },
                { value: 1025.8297, timeStamp: 1438798500000 },
                { value: 1115.0323, timeStamp: 1439403300000 },
                { value: 1202.0048, timeStamp: 1440008100000 },
                { value: 1150.7133, timeStamp: 1440612900000 },
                { value: 1099.4218, timeStamp: 1441217700000 },
                { value: 1115.0323, timeStamp: 1441822500000 },
                { value: 1177.4741, timeStamp: 1442427300000 },
                { value: 1148.4832, timeStamp: 1443032100000 },
                { value: 1146.2532, timeStamp: 1443896100000 },
                { value: 1059.2806, timeStamp: 1444500900000 },
                { value: 1051.6984, timeStamp: 1445105700000 },
                { value: 1050.8064, timeStamp: 1445710500000 },
                { value: 1014.6793, timeStamp: 1446315300000 },
                { value: 1003.083, timeStamp: 1446920100000 },
                { value: 1028.0597, timeStamp: 1447524900000 },
                { value: 983.4584, timeStamp: 1448129700000 },
                { value: 900.9461, timeStamp: 1448734500000 },
                { value: 1057.8233, timeStamp: 1449339300000 },
                { value: 1106.6727, timeStamp: 1449944100000 },
                { value: 1064.2202, timeStamp: 1450548900000 },
                { value: 1046.774, timeStamp: 1451153700000 },
                { value: 1070.0356, timeStamp: 1451758500000 },
                { value: 1058.4048, timeStamp: 1452363300000 },
                { value: 1099.1127, timeStamp: 1452968100000 },
                { value: 1102.0204, timeStamp: 1453572900000 },
                { value: 1099.1127, timeStamp: 1454177700000 },
                { value: 1125.282, timeStamp: 1454782500000 },
                { value: 1104.9281, timeStamp: 1455387300000 },
                { value: 1108.9989, timeStamp: 1455992100000 },
                { value: 1116.5589, timeStamp: 1456596900000 },
                { value: 1110.1619, timeStamp: 1457201700000 },
                { value: 1102.0204, timeStamp: 1457892900000 },
                { value: 1115.9774, timeStamp: 1458497700000 },
                { value: 1220.6548, timeStamp: 1459188900000 },
                { value: 1216.0024, timeStamp: 1459793700000 },
                { value: 1227.0517, timeStamp: 1460398500000 },
                { value: 1314.2829, timeStamp: 1461089700000 },
                { value: 1297.9997, timeStamp: 1461694500000 },
                { value: 1314.2829, timeStamp: 1462299300000 },
                { value: 1319.5167, timeStamp: 1462904100000 },
                { value: 1320.0983, timeStamp: 1463508900000 },
                { value: 1325.9137, timeStamp: 1464113700000 },
                { value: 1291.0212, timeStamp: 1464718500000 },
                { value: 1303.2336, timeStamp: 1465323300000 },
                { value: 1331.1476, timeStamp: 1465928100000 },
                { value: 1342.1968, timeStamp: 1466532900000 },
                { value: 1424.7757, timeStamp: 1467137700000 },
                { value: 1381.1601, timeStamp: 1467742500000 },
                { value: 1354.9908, timeStamp: 1468347300000 },
                { value: 1407.3294, timeStamp: 1468952100000 },
                { value: 1434.0803, timeStamp: 1469556900000 },
                { value: 1386.9755, timeStamp: 1470161700000 },
                { value: 1366.6216, timeStamp: 1470766500000 },
                { value: 1331.7291, timeStamp: 1471371300000 },
                { value: 1337.5445, timeStamp: 1471976100000 },
                { value: 1372.437, timeStamp: 1472580900000 },
                { value: 1435.2434, timeStamp: 1473185700000 },
                { value: 1402.0956, timeStamp: 1473790500000 },
                { value: 1342.8631, timeStamp: 1474481700000 },
                { value: 1363.4055, timeStamp: 1475086500000 },
                { value: 1354.2756, timeStamp: 1475691300000 },
                { value: 1358.0797, timeStamp: 1476900900000 },
                { value: 1335.2549, timeStamp: 1477505700000 },
                { value: 1339.059, timeStamp: 1478110500000 },
                { value: 1293.4093, timeStamp: 1478715300000 },
                { value: 1270.5844, timeStamp: 1479320100000 },
                { value: 1213.5222, timeStamp: 1479924900000 },
                { value: 1273.6277, timeStamp: 1480529700000 },
                { value: 1240.1512, timeStamp: 1481134500000 },
                { value: 1202.1098, timeStamp: 1481739300000 },
                { value: 1164.0683, timeStamp: 1482344100000 },
                { value: 1155.6992, timeStamp: 1482948900000 },
                { value: 1145.0476, timeStamp: 1483553700000 },
                { value: 1186.8932, timeStamp: 1484158500000 },
                { value: 1141.2435, timeStamp: 1484763300000 },
                { value: 1089.5071, timeStamp: 1485368100000 },
                { value: 1107.0062, timeStamp: 1485972900000 },
                { value: 1042.3357, timeStamp: 1486577700000 },
                { value: 1107.767, timeStamp: 1487182500000 },
                { value: 1119.1794, timeStamp: 1487787300000 },
                { value: 1080.3771, timeStamp: 1488392100000 },
                { value: 1092.5504, timeStamp: 1488996900000 },
                { value: 1095.5937, timeStamp: 1489601700000 },
                { value: 1118.4186, timeStamp: 1490206500000 },
                { value: 1179.2849, timeStamp: 1490811300000 },
                { value: 1194.5015, timeStamp: 1491416100000 },
                { value: 1209.7181, timeStamp: 1492020900000 },
                { value: 1180.0457, timeStamp: 1492625700000 },
                { value: 1202.1098, timeStamp: 1493230500000 },
                { value: 1186.8932, timeStamp: 1493835300000 },
                { value: 1186.8932, timeStamp: 1494440100000 },
                { value: 1179.2849, timeStamp: 1495304100000 },
                { value: 1170.155, timeStamp: 1495908900000 },
                { value: 1126.0269, timeStamp: 1496513700000 },
                { value: 1119.9403, timeStamp: 1497118500000 },
                { value: 1110.0495, timeStamp: 1497723300000 },
                { value: 1132.8743, timeStamp: 1498328100000 },
                { value: 1125.2661, timeStamp: 1498932900000 },
                { value: 1141.2435, timeStamp: 1499537700000 },
                { value: 1164.0683, timeStamp: 1500142500000 },
                { value: 1243.9554, timeStamp: 1500747300000 },
                { value: 1232.5429, timeStamp: 1501352100000 },
                { value: 1314.7125, timeStamp: 1501956900000 },
                { value: 1331.4507, timeStamp: 1502561700000 },
                { value: 1308.6258, timeStamp: 1503252900000 },
                { value: 1340.5807, timeStamp: 1503857700000 },
                { value: 1266.7802, timeStamp: 1504462500000 },
                { value: 1240.1512, timeStamp: 1505067300000 },
                { value: 1264, timeStamp: 1505672100000 },
                { value: 1264, timeStamp: 1506363300000 },
                { value: 1245, timeStamp: 1507054500000 },
                { value: 1200, timeStamp: 1507659300000 },
                { value: 1277, timeStamp: 1508264100000 },
                { value: 1235, timeStamp: 1508868900000 },
                { value: 1215, timeStamp: 1509560100000 },
                { value: 1130, timeStamp: 1510164900000 },
                { value: 1182, timeStamp: 1510769700000 },
                { value: 1166, timeStamp: 1511374500000 },
                { value: 1179, timeStamp: 1511979300000 },
            ],
        },
      */
    },

    equityFinancials: {
        /*
        NABIL: {
            keyStats: {
                data: [
                    {
                        idcbKeyStats: 586,
                        Ticker: 'NABIL',
                        Year: '2016/17',
                        Quarter: 4,
                        DataSource: 'Published',
                        TotalRevenue: 8065591,
                        GrowthOverPriorPeriod: 0.3987,
                        GrossProfit: 5459500,
                        GrossProfitMargin: 0.6769,
                        NetIncome: 3620821,
                        NetIncomeMargin: 0.4489,
                        ReturnOnAsset: 0.0262,
                        ReturnOnEquity: 0.2681,
                        EpsAnnualized: 58.5372,
                        ReportedPeAnnualized: 26.0177,
                        BookValuePerShare: 245.9919,
                        DividendPerShare: 48,
                        CapitalFundToRwa: 0.1334,
                        NonPerformingLoanNplToTotalLoan: 0.0079,
                        TotalLoanLossProvisionToTotalNpl: 2.2175,
                        CostOfFunds: 0.027,
                        CreditDepositRatioAsPerNrbCalculations: 0.7562,
                        BaseRate: 0.0661,
                        NetInterestSpread: 0.0492,
                        AverageYield: 0.0689,
                        Mps: 1523,
                        NetLiquidAsset: 0.2584,
                    },
                    {
                        idcbKeyStats: 585,
                        Ticker: 'NABIL',
                        Year: '2016/17',
                        Quarter: 3,
                        DataSource: 'Published',
                        TotalRevenue: 5718067,
                        GrowthOverPriorPeriod: 0.4328,
                        GrossProfit: 4081821,
                        GrossProfitMargin: 0.7138,
                        NetIncome: 2683740,
                        NetIncomeMargin: 0.4693,
                        ReturnOnAsset: 0.0251,
                        ReturnOnEquity: 0.2704,
                        EpsAnnualized: 57.8501,
                        ReportedPeAnnualized: 27.4848,
                        BookValuePerShare: 230.8423,
                        DividendPerShare: 0,
                        CapitalFundToRwa: 0.1284,
                        NonPerformingLoanNplToTotalLoan: 0.0095,
                        TotalLoanLossProvisionToTotalNpl: 1.9212,
                        CostOfFunds: 0.0228,
                        CreditDepositRatioAsPerNrbCalculations: 0.7975,
                        BaseRate: 0.0571,
                        NetInterestSpread: 0.0533,
                        AverageYield: 0.0658,
                        Mps: 1590,
                        NetLiquidAsset: 0.2587,
                    },
                    {
                        idcbKeyStats: 582,
                        Ticker: 'NABIL',
                        Year: '2015/16',
                        Quarter: 4,
                        DataSource: 'Published',
                        TotalRevenue: 6155660,
                        GrowthOverPriorPeriod: 0.1308,
                        GrossProfit: 4325971,
                        GrossProfitMargin: 0.7028,
                        NetIncome: 2821564,
                        NetIncomeMargin: 0.4584,
                        ReturnOnAsset: 0.0223,
                        ReturnOnEquity: 0.2586,
                        EpsAnnualized: 59.3193,
                        ReportedPeAnnualized: 39.515,
                        BookValuePerShare: 258.7742,
                        DividendPerShare: 45,
                        CapitalFundToRwa: 0.1255,
                        NonPerformingLoanNplToTotalLoan: 0.0114,
                        TotalLoanLossProvisionToTotalNpl: 1.8232,
                        CostOfFunds: 0.0208,
                        CreditDepositRatioAsPerNrbCalculations: 0.7384,
                        BaseRate: 0.0417,
                        NetInterestSpread: 0.0498,
                        AverageYield: 0,
                        Mps: 2344,
                        NetLiquidAsset: 0,
                    },
                ],
                format: [
                    {
                        idcbkeystatsmapping: 1,
                        MySqlColumnName: 'TotalRevenue',
                        WorkSheetColumnName: 'Total Revenue (Rs. 000)',
                        HeadingStyle: 'heading2BoldIndent1',
                        RowStyle: 'row2White',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbkeystatsmapping: 2,
                        MySqlColumnName: 'GrowthOverPriorPeriod',
                        WorkSheetColumnName: 'Growth Period on Period',
                        HeadingStyle: 'heading3Indent2',
                        RowStyle: 'row2Italics',
                        Format: 'Percentage',
                        fchartdisplaystatus: 0,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbkeystatsmapping: 3,
                        MySqlColumnName: 'GrossProfit',
                        WorkSheetColumnName: 'Gross Profit (Rs. 000)',
                        HeadingStyle: 'heading2BoldIndent1',
                        RowStyle: 'row2White',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbkeystatsmapping: 4,
                        MySqlColumnName: 'GrossProfitMargin',
                        WorkSheetColumnName: 'Margin (MRQ) %',
                        HeadingStyle: 'heading3Indent2',
                        RowStyle: 'row2Italics',
                        Format: 'Percentage',
                        fchartdisplaystatus: 1,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbkeystatsmapping: 5,
                        MySqlColumnName: 'NetIncome',
                        WorkSheetColumnName: 'Net Income (Rs. 000)',
                        HeadingStyle: 'heading2BoldIndent1',
                        RowStyle: 'row2White',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbkeystatsmapping: 6,
                        MySqlColumnName: 'NetIncomeMargin',
                        WorkSheetColumnName: 'Margin (MRQ) %',
                        HeadingStyle: 'heading3Indent2',
                        RowStyle: 'row2Italics',
                        Format: 'Percentage',
                        fchartdisplaystatus: 1,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbkeystatsmapping: 7,
                        MySqlColumnName: 'ReturnOnAsset',
                        WorkSheetColumnName: 'Return on Asset (TTM)',
                        HeadingStyle: 'heading2BoldIndent1',
                        RowStyle: 'row2White',
                        Format: 'Percentage',
                        fchartdisplaystatus: 1,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbkeystatsmapping: 8,
                        MySqlColumnName: 'ReturnOnEquity',
                        WorkSheetColumnName: 'Return on Equity (TTM)',
                        HeadingStyle: 'heading2BoldIndent1',
                        RowStyle: 'row2White',
                        Format: 'Percentage',
                        fchartdisplaystatus: 1,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbkeystatsmapping: 9,
                        MySqlColumnName: 'EpsAnnualized',
                        WorkSheetColumnName: 'EPS (Annualized)',
                        HeadingStyle: 'heading2BoldIndent1',
                        RowStyle: 'row2White',
                        Format: 'Regular',
                        fchartdisplaystatus: 1,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbkeystatsmapping: 10,
                        MySqlColumnName: 'ReportedPeAnnualized',
                        WorkSheetColumnName: 'Reported PE (Annualized)',
                        HeadingStyle: 'heading2BoldIndent1',
                        RowStyle: 'row2White',
                        Format: 'Regular',
                        fchartdisplaystatus: 1,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbkeystatsmapping: 11,
                        MySqlColumnName: 'BookValuePerShare',
                        WorkSheetColumnName: 'Book Value per Share',
                        HeadingStyle: 'heading2BoldIndent1',
                        RowStyle: 'row2White',
                        Format: 'Regular',
                        fchartdisplaystatus: 1,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbkeystatsmapping: 12,
                        MySqlColumnName: 'Mps',
                        WorkSheetColumnName: 'Market Value per Share',
                        HeadingStyle: 'heading2BoldIndent1',
                        RowStyle: 'row2White',
                        Format: 'Regular',
                        fchartdisplaystatus: 1,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbkeystatsmapping: 13,
                        MySqlColumnName: 'DividendPerShare',
                        WorkSheetColumnName: 'Dividend Per Share (Rs.)',
                        HeadingStyle: 'heading2BoldIndent1',
                        RowStyle: 'row2White',
                        Format: 'Regular',
                        fchartdisplaystatus: 1,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbkeystatsmapping: 14,
                        MySqlColumnName: 'FinancialSector',
                        WorkSheetColumnName: 'FINANCIAL SECTOR',
                        HeadingStyle: 'heading1Bold',
                        RowStyle: 'row1',
                        Format: 'Blank',
                        fchartdisplaystatus: 0,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbkeystatsmapping: 15,
                        MySqlColumnName: 'CapitalFundToRwa',
                        WorkSheetColumnName: 'Capital Fund to RWA',
                        HeadingStyle: 'heading2BoldIndent1',
                        RowStyle: 'row2',
                        Format: 'Percentage',
                        fchartdisplaystatus: 1,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbkeystatsmapping: 16,
                        MySqlColumnName: 'NonPerformingLoanNplToTotalLoan',
                        WorkSheetColumnName: 'Non Performing Loan (NPL) to Total Loan',
                        HeadingStyle: 'heading2BoldIndent1',
                        RowStyle: 'row2',
                        Format: 'Percentage',
                        fchartdisplaystatus: 1,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbkeystatsmapping: 17,
                        MySqlColumnName: 'TotalLoanLossProvisionToTotalNpl',
                        WorkSheetColumnName: 'Total Loan Loss Provision to Total NPL',
                        HeadingStyle: 'heading2BoldIndent1',
                        RowStyle: 'row2',
                        Format: 'Percentage',
                        fchartdisplaystatus: 1,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbkeystatsmapping: 18,
                        MySqlColumnName: 'CostOfFunds',
                        WorkSheetColumnName: 'Cost of Funds',
                        HeadingStyle: 'heading2BoldIndent1',
                        RowStyle: 'row2',
                        Format: 'Percentage',
                        fchartdisplaystatus: 1,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbkeystatsmapping: 19,
                        MySqlColumnName: 'CreditDepositRatioAsPerNrbCalculations',
                        WorkSheetColumnName: 'Credit Deposit Ratio as per NRB Calculations',
                        HeadingStyle: 'heading2BoldIndent1',
                        RowStyle: 'row2',
                        Format: 'Percentage',
                        fchartdisplaystatus: 1,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbkeystatsmapping: 20,
                        MySqlColumnName: 'BaseRate',
                        WorkSheetColumnName: 'Base Rate',
                        HeadingStyle: 'heading2BoldIndent1',
                        RowStyle: 'row2',
                        Format: 'Percentage',
                        fchartdisplaystatus: 1,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbkeystatsmapping: 21,
                        MySqlColumnName: 'NetInterestSpread',
                        WorkSheetColumnName: 'Net Interest Spread',
                        HeadingStyle: 'heading2BoldIndent1',
                        RowStyle: 'row2',
                        Format: 'Percentage',
                        fchartdisplaystatus: 1,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbkeystatsmapping: 22,
                        MySqlColumnName: 'AverageYield',
                        WorkSheetColumnName: 'Average Yield',
                        HeadingStyle: 'heading2BoldIndent1',
                        RowStyle: 'row2',
                        Format: 'Percentage',
                        fchartdisplaystatus: 1,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbkeystatsmapping: 23,
                        MySqlColumnName: 'NetLiquidAsset',
                        WorkSheetColumnName: 'Net Liquid Asset',
                        HeadingStyle: 'heading2BoldIndent1',
                        RowStyle: 'row2',
                        Format: 'Percentage',
                        fchartdisplaystatus: 1,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbkeystatsmapping: 24,
                        MySqlColumnName: 'LatestCapitalization',
                        WorkSheetColumnName: 'LATEST CAPITALIZATION',
                        HeadingStyle: 'heading1Bold',
                        RowStyle: 'row1',
                        Format: 'Blank',
                        fchartdisplaystatus: 0,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbkeystatsmapping: 25,
                        MySqlColumnName: 'OutstandingShares',
                        WorkSheetColumnName: 'Outstanding Shares',
                        HeadingStyle: 'heading3Indent2',
                        RowStyle: 'row3',
                        Format: 'Regular',
                        fchartdisplaystatus: 0,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbkeystatsmapping: 26,
                        MySqlColumnName: 'Tier1Capital',
                        WorkSheetColumnName: 'Tier 1 Capital (Rs. 000)',
                        HeadingStyle: 'heading2BoldIndent1',
                        RowStyle: 'row2',
                        Format: 'Regular',
                        fchartdisplaystatus: 0,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbkeystatsmapping: 27,
                        MySqlColumnName: 'Tier2Capital',
                        WorkSheetColumnName: 'Tier 2 Capital (Rs. 000)',
                        HeadingStyle: 'heading2BoldIndent1',
                        RowStyle: 'row2',
                        Format: 'Regular',
                        fchartdisplaystatus: 0,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbkeystatsmapping: 28,
                        MySqlColumnName: 'TotalCapital',
                        WorkSheetColumnName: 'Total Capital (Rs. 000)',
                        HeadingStyle: 'heading2BoldIndent1',
                        RowStyle: 'row2',
                        Format: 'Regular',
                        fchartdisplaystatus: 0,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbkeystatsmapping: 29,
                        MySqlColumnName: 'Tier1CapitalRatio',
                        WorkSheetColumnName: 'Tier 1 Capital Ratio %',
                        HeadingStyle: 'heading2BoldIndent1',
                        RowStyle: 'row2',
                        Format: 'Percentage',
                        fchartdisplaystatus: 0,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbkeystatsmapping: 30,
                        MySqlColumnName: 'Tier2CapitalRatio',
                        WorkSheetColumnName: 'Tier 2 Capital Ratio %',
                        HeadingStyle: 'heading2BoldIndent1',
                        RowStyle: 'row2',
                        Format: 'Percentage',
                        fchartdisplaystatus: 0,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                ],
            },
            balanceSheet: {
                data: [
                    {
                        idcbbalancesheet2: 921,
                        Ticker: 'NABIL',
                        Year: '2016/17',
                        Quarter: 4,
                        DataSource: 'Published',
                        Statement: 'Balance Sheet',
                        TotalCapitalAndLiabilities: 141943924,
                        PaidUpCapital: 6185507,
                        ReservesAndSurplus: 9030340,
                        DebenturesAndBonds: 300000,
                        Borrowings: 3056310,
                        Deposits: 118896157,
                        DomesticCurrency: 101418039,
                        ForeignCurrency: 17478118,
                        IncomeTaxLiabilities: 0,
                        OtherLiabilities: 4475610,
                        TotalAssets: 141943923,
                        CashAndBankBalance: 13091725,
                        MoneyAtCallAndShortNotice: 773625,
                        Investments: 31821046,
                        LoanAndAdvances: 91491252,
                        RealEstateLoan: 4028251,
                        ResidentialRealEstateLoanAbove10Million: 1421936,
                        BusinessComplexAndResidentialApartmentConstructionLoan: 287124,
                        IncomeGeneratingCommercialComplexLoan: 223373,
                        OtherRealEstateLoan: 2095818,
                        PersonalHomeLoanUpto10MillionOrLess: 7074366,
                        MarginTypeLoan: 1409716,
                        TermLoan: 16949720,
                        OverdraftLoanAndTrLoanAndWcLoan: 51441742,
                        OtherLoan: 10587457,
                        FixedAssets: 852379,
                        NonBankingAssets: 0,
                        OtherAssets: 3913896,
                        OrdinaryShares: 61855.07,
                        PrefShares: 0,
                    },
                    {
                        idcbbalancesheet2: 893,
                        Ticker: 'NABIL',
                        Year: '2016/17',
                        Quarter: 3,
                        DataSource: 'Published',
                        Statement: 'BalanceSheet',
                        TotalCapitalAndLiabilities: 137252512,
                        PaidUpCapital: 6185507,
                        ReservesAndSurplus: 8093259,
                        DebenturesAndBonds: 300000,
                        Borrowings: 9485,
                        Deposits: 117059624,
                        DomesticCurrency: 96077188,
                        ForeignCurrency: 20982436,
                        IncomeTaxLiabilities: 47045,
                        OtherLiabilities: 5557592,
                        TotalAssets: 137252510,
                        CashAndBankBalance: 10493211,
                        MoneyAtCallAndShortNotice: 2471758,
                        Investments: 28226502,
                        LoanAndAdvances: 90554766,
                        RealEstateLoan: 4021762,
                        ResidentialRealEstateLoanAbove10Million: 1570848,
                        BusinessComplexAndResidentialApartmentConstructionLoan: 292002,
                        IncomeGeneratingCommercialComplexLoan: 2335814,
                        OtherRealEstateLoan: 1925332,
                        PersonalHomeLoanUpto10MillionOrLess: 7155987,
                        MarginTypeLoan: 1575533,
                        TermLoan: 16006968,
                        OverdraftLoanAndTrLoanAndWcLoan: 51397237,
                        OtherLoan: 10397279,
                        FixedAssets: 802024,
                        NonBankingAssets: 0,
                        OtherAssets: 4704249,
                        OrdinaryShares: 61855.07,
                        PrefShares: 0,
                    },
                    {
                        idcbbalancesheet2: 457,
                        Ticker: 'NABIL',
                        Year: '2015/16',
                        Quarter: 4,
                        DataSource: 'Published',
                        Statement: 'BalanceSheet',
                        TotalCapitalAndLiabilities: 128919597,
                        PaidUpCapital: 4756570,
                        ReservesAndSurplus: 7552205,
                        DebenturesAndBonds: 300000,
                        Borrowings: 1900000,
                        Deposits: 110267272,
                        DomesticCurrency: 89399613,
                        ForeignCurrency: 20867659,
                        IncomeTaxLiabilities: -4269,
                        OtherLiabilities: 4147819,
                        TotalAssets: 128919596,
                        CashAndBankBalance: 10262849,
                        MoneyAtCallAndShortNotice: 819418,
                        Investments: 36098791,
                        LoanAndAdvances: 77730401,
                        RealEstateLoan: 3559513,
                        ResidentialRealEstateLoanAbove10Million: 1482093,
                        BusinessComplexAndResidentialApartmentConstructionLoan: 309266,
                        IncomeGeneratingCommercialComplexLoan: 262661,
                        OtherRealEstateLoan: 1505493,
                        PersonalHomeLoanUpto10MillionOrLess: 6518473,
                        MarginTypeLoan: 893919,
                        TermLoan: 13658225,
                        OverdraftLoanAndTrLoanAndWcLoan: 44226788,
                        OtherLoan: 8873483,
                        FixedAssets: 784456,
                        NonBankingAssets: 0,
                        OtherAssets: 3223681,
                        OrdinaryShares: 47565.7,
                        PrefShares: 0,
                    },
                ],
                format: [
                    {
                        idcbBalanceSheetMap: 1,
                        MySqlColumnName: 'TotalCapitalAndLiabilities',
                        WorkSheetColumnName: 'CAPITAL & LIABILITIES',
                        HeadingStyle: 'heading1BoldNoHighlight',
                        RowStyle: 'row2White',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbBalanceSheetMap: 2,
                        MySqlColumnName: 'PaidUpCapital',
                        WorkSheetColumnName: 'Paid Up Capital',
                        HeadingStyle: 'heading2Indent1',
                        RowStyle: 'row3',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbBalanceSheetMap: 3,
                        MySqlColumnName: 'ReservesAndSurplus',
                        WorkSheetColumnName: 'Reserves and Surplus',
                        HeadingStyle: 'heading2Indent1',
                        RowStyle: 'row3',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbBalanceSheetMap: 4,
                        MySqlColumnName: 'DebenturesAndBonds',
                        WorkSheetColumnName: 'Debentures and Bonds',
                        HeadingStyle: 'heading2Indent1',
                        RowStyle: 'row3',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbBalanceSheetMap: 5,
                        MySqlColumnName: 'Borrowings',
                        WorkSheetColumnName: 'Borrowings',
                        HeadingStyle: 'heading2Indent1',
                        RowStyle: 'row3',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbBalanceSheetMap: 6,
                        MySqlColumnName: 'Deposits',
                        WorkSheetColumnName: 'Deposits',
                        HeadingStyle: 'heading2BoldIndent1',
                        RowStyle: 'row3',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbBalanceSheetMap: 7,
                        MySqlColumnName: 'DomesticCurrency',
                        WorkSheetColumnName: 'Domestic Currency',
                        HeadingStyle: 'heading3ItalicsIndent2',
                        RowStyle: 'row3Italics',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbBalanceSheetMap: 8,
                        MySqlColumnName: 'ForeignCurrency',
                        WorkSheetColumnName: 'Foreign Currency',
                        HeadingStyle: 'heading3ItalicsIndent2',
                        RowStyle: 'row3Italics',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbBalanceSheetMap: 9,
                        MySqlColumnName: 'IncomeTaxLiabilities',
                        WorkSheetColumnName: 'Income Tax Liabilities',
                        HeadingStyle: 'heading2Indent1',
                        RowStyle: 'row3',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbBalanceSheetMap: 10,
                        MySqlColumnName: 'OtherLiabilities',
                        WorkSheetColumnName: 'Other Liabilities',
                        HeadingStyle: 'heading2Indent1',
                        RowStyle: 'row3',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbBalanceSheetMap: 11,
                        MySqlColumnName: 'TotalAssets',
                        WorkSheetColumnName: 'ASSETS',
                        HeadingStyle: 'heading1BoldNoHighlight',
                        RowStyle: 'row2White',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbBalanceSheetMap: 12,
                        MySqlColumnName: 'CashAndBankBalance',
                        WorkSheetColumnName: 'Cash and Bank Balance',
                        HeadingStyle: 'heading2Indent1',
                        RowStyle: 'row3',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbBalanceSheetMap: 13,
                        MySqlColumnName: 'MoneyAtCallAndShortNotice',
                        WorkSheetColumnName: 'Money at Call and Short Notice',
                        HeadingStyle: 'heading2Indent1',
                        RowStyle: 'row3',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbBalanceSheetMap: 14,
                        MySqlColumnName: 'Investments',
                        WorkSheetColumnName: 'Investments',
                        HeadingStyle: 'heading2Indent1',
                        RowStyle: 'row3',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbBalanceSheetMap: 15,
                        MySqlColumnName: 'LoanAndAdvances',
                        WorkSheetColumnName: 'Loan and Advances',
                        HeadingStyle: 'heading2BoldIndent1',
                        RowStyle: 'row3',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbBalanceSheetMap: 16,
                        MySqlColumnName: 'RealEstateLoan',
                        WorkSheetColumnName: 'Real Estate Loan',
                        HeadingStyle: 'heading3Indent2',
                        RowStyle: 'row4',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbBalanceSheetMap: 17,
                        MySqlColumnName: 'ResidentialRealEstateLoanAbove10Million',
                        WorkSheetColumnName: 'Residential Real Estate Loan above 10 Million',
                        HeadingStyle: 'heading4ItalicsIndent3',
                        RowStyle: 'row4Italics',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbBalanceSheetMap: 18,
                        MySqlColumnName: 'BusinessComplexAndResidentialApartmentConstructionLoan',
                        WorkSheetColumnName: 'Business Complex ...',
                        HeadingStyle: 'heading4ItalicsIndent3',
                        RowStyle: 'row4Italics',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbBalanceSheetMap: 19,
                        MySqlColumnName: 'IncomeGeneratingCommercialComplexLoan',
                        WorkSheetColumnName: 'Income Generating Commercial Complex Loan',
                        HeadingStyle: 'heading4ItalicsIndent3',
                        RowStyle: 'row4Italics',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbBalanceSheetMap: 20,
                        MySqlColumnName: 'OtherRealEstateLoan',
                        WorkSheetColumnName: 'Other Real Estate Loan',
                        HeadingStyle: 'heading4ItalicsIndent3',
                        RowStyle: 'row4Italics',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbBalanceSheetMap: 21,
                        MySqlColumnName: 'PersonalHomeLoanUpto10MillionOrLess',
                        WorkSheetColumnName: 'Personal Home Loan upto 10 Million or Less',
                        HeadingStyle: 'heading3Indent2',
                        RowStyle: 'row4',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbBalanceSheetMap: 22,
                        MySqlColumnName: 'MarginTypeLoan',
                        WorkSheetColumnName: 'Margin Type Loan',
                        HeadingStyle: 'heading3Indent2',
                        RowStyle: 'row4',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbBalanceSheetMap: 23,
                        MySqlColumnName: 'TermLoan',
                        WorkSheetColumnName: 'Term Loan',
                        HeadingStyle: 'heading3Indent2',
                        RowStyle: 'row4',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbBalanceSheetMap: 24,
                        MySqlColumnName: 'OverdraftLoanAndTrLoanAndWcLoan',
                        WorkSheetColumnName: 'Overdraft Loan and TR Loan and WC Loan',
                        HeadingStyle: 'heading3Indent2',
                        RowStyle: 'row4',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbBalanceSheetMap: 25,
                        MySqlColumnName: 'OtherLoan',
                        WorkSheetColumnName: 'Other Loan',
                        HeadingStyle: 'heading3Indent2',
                        RowStyle: 'row4',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbBalanceSheetMap: 26,
                        MySqlColumnName: 'FixedAssets',
                        WorkSheetColumnName: 'Fixed Assets',
                        HeadingStyle: 'heading2Indent1',
                        RowStyle: 'row3',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbBalanceSheetMap: 27,
                        MySqlColumnName: 'NonBankingAssets',
                        WorkSheetColumnName: 'Non Banking Assets',
                        HeadingStyle: 'heading2Indent1',
                        RowStyle: 'row3',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbBalanceSheetMap: 28,
                        MySqlColumnName: 'OtherAssets',
                        WorkSheetColumnName: 'Other Assets',
                        HeadingStyle: 'heading2Indent1',
                        RowStyle: 'row3',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                ],
            },
            incomeStatement: {
                data: [
                    {
                        idcbincomestatement: 921,
                        Ticker: 'NABIL',
                        Year: '2016/17',
                        Quarter: 4,
                        DataSource: 'Published',
                        Statement: 'Income Statement',
                        InterestIncome: 8065591,
                        InterestExpense: 2606091,
                        NetInterestIncome: 5459500,
                        FeesAndCommissionAndDiscount: 579803,
                        OtherOperatingIncome: 382107,
                        ForeignExchangeGainAndLoss: 647266,
                        TotalOperatingIncome: 7068676,
                        StaffExpenses: 932356,
                        OtherOperatingExpenses: 652414,
                        OperatingProfitBeforeProvision: 5483906,
                        ProvisionForPossibleLosses: 19351,
                        OperatingProfit: 5464555,
                        NonOperatingIncomeAndExpenses: 148781,
                        WriteBackOfProvisionForPossibleLoss: 42969,
                        ProfitFromRegularActivities: 5656305,
                        ExtraordinaryIncomeAndExpenses: 11260,
                        ProfitBeforeBonusAndTaxes: 5667565,
                        ProvisionForStaffBonus: 515233,
                        ProvisionForTax: 1531511,
                        NetProfitOrLoss: 3620821,
                        PrefShareDiv: 0,
                    },
                    {
                        idcbincomestatement: 893,
                        Ticker: 'NABIL',
                        Year: '2016/17',
                        Quarter: 3,
                        DataSource: 'Published',
                        Statement: 'Income Statement',
                        InterestIncome: 5718067,
                        InterestExpense: 1636246,
                        NetInterestIncome: 4081821,
                        FeesAndCommissionAndDiscount: 414300,
                        OtherOperatingIncome: 282665,
                        ForeignExchangeGainAndLoss: 460567,
                        TotalOperatingIncome: 5239353,
                        StaffExpenses: 634076,
                        OtherOperatingExpenses: 474009,
                        OperatingProfitBeforeProvision: 4131268,
                        ProvisionForPossibleLosses: 30362,
                        OperatingProfit: 4100906,
                        NonOperatingIncomeAndExpenses: 85523,
                        WriteBackOfProvisionForPossibleLoss: 514,
                        ProfitFromRegularActivities: 4186943,
                        ExtraordinaryIncomeAndExpenses: 8526,
                        ProfitBeforeBonusAndTaxes: 4195469,
                        ProvisionForStaffBonus: 381406,
                        ProvisionForTax: 1130323,
                        NetProfitOrLoss: 2683740,
                        PrefShareDiv: 0,
                    },
                    {
                        idcbincomestatement: 386,
                        Ticker: 'NABIL',
                        Year: '2015/16',
                        Quarter: 4,
                        DataSource: 'Published',
                        Statement: 'Income Statement',
                        InterestIncome: 6155660,
                        InterestExpense: 1829689,
                        NetInterestIncome: 4325971,
                        FeesAndCommissionAndDiscount: 484961,
                        OtherOperatingIncome: 332650,
                        ForeignExchangeGainAndLoss: 586057,
                        TotalOperatingIncome: 5729639,
                        StaffExpenses: 775306,
                        OtherOperatingExpenses: 604809,
                        OperatingProfitBeforeProvision: 4349524,
                        ProvisionForPossibleLosses: 5082,
                        OperatingProfit: 4344442,
                        NonOperatingIncomeAndExpenses: 59256,
                        WriteBackOfProvisionForPossibleLoss: 55661,
                        ProfitFromRegularActivities: 4459359,
                        ExtraordinaryIncomeAndExpenses: -47301,
                        ProfitBeforeBonusAndTaxes: 4412058,
                        ProvisionForStaffBonus: 401096,
                        ProvisionForTax: 1189398,
                        NetProfitOrLoss: 2821564,
                        PrefShareDiv: 0,
                    },
                ],
                format: [
                    {
                        idcbIncomeStatementMap: 1,
                        MySqlColumnName: 'InterestIncome',
                        WorkSheetColumnName: 'Interest Income',
                        HeadingStyle: 'heading2Indent1',
                        RowStyle: 'row3',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbIncomeStatementMap: 2,
                        MySqlColumnName: 'InterestExpense',
                        WorkSheetColumnName: 'Interest Expense',
                        HeadingStyle: 'heading2Indent1',
                        RowStyle: 'row3',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbIncomeStatementMap: 3,
                        MySqlColumnName: 'NetInterestIncome',
                        WorkSheetColumnName: 'Net Interest Income',
                        HeadingStyle: 'heading1BoldNoHighlight',
                        RowStyle: 'row2White',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbIncomeStatementMap: 4,
                        MySqlColumnName: 'FeesAndCommissionAndDiscount',
                        WorkSheetColumnName: 'Fees, Commission and Discount',
                        HeadingStyle: 'heading2Indent1',
                        RowStyle: 'row3',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbIncomeStatementMap: 5,
                        MySqlColumnName: 'OtherOperatingIncome',
                        WorkSheetColumnName: 'Other Operating Income',
                        HeadingStyle: 'heading2Indent1',
                        RowStyle: 'row3',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbIncomeStatementMap: 6,
                        MySqlColumnName: 'ForeignExchangeGainAndLoss',
                        WorkSheetColumnName: 'Foreign Exchange Gain/Loss (Net)',
                        HeadingStyle: 'heading2Indent1',
                        RowStyle: 'row3',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbIncomeStatementMap: 7,
                        MySqlColumnName: 'TotalOperatingIncome',
                        WorkSheetColumnName: 'Total Operating Income',
                        HeadingStyle: 'heading1BoldNoHighlight',
                        RowStyle: 'row2White',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbIncomeStatementMap: 8,
                        MySqlColumnName: 'StaffExpenses',
                        WorkSheetColumnName: 'Staff Expenses',
                        HeadingStyle: 'heading2Indent1',
                        RowStyle: 'row3',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbIncomeStatementMap: 9,
                        MySqlColumnName: 'OtherOperatingExpenses',
                        WorkSheetColumnName: 'Other Operating Expenses',
                        HeadingStyle: 'heading2Indent1',
                        RowStyle: 'row3',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbIncomeStatementMap: 10,
                        MySqlColumnName: 'OperatingProfitBeforeProvision',
                        WorkSheetColumnName: 'Operating Profit Before Provision',
                        HeadingStyle: 'heading1BoldNoHighlight',
                        RowStyle: 'row2White',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbIncomeStatementMap: 11,
                        MySqlColumnName: 'ProvisionForPossibleLosses',
                        WorkSheetColumnName: 'Provision for Possible Losses',
                        HeadingStyle: 'heading2Indent1',
                        RowStyle: 'row3',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbIncomeStatementMap: 12,
                        MySqlColumnName: 'OperatingProfit',
                        WorkSheetColumnName: 'Operating Profit',
                        HeadingStyle: 'heading1BoldNoHighlight',
                        RowStyle: 'row2White',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbIncomeStatementMap: 13,
                        MySqlColumnName: 'NonOperatingIncomeAndExpenses',
                        WorkSheetColumnName: 'Non Operating Income/Expenses (Net)',
                        HeadingStyle: 'heading2Indent1',
                        RowStyle: 'row3',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbIncomeStatementMap: 14,
                        MySqlColumnName: 'WriteBackOfProvisionForPossibleLoss',
                        WorkSheetColumnName: 'Write Back of Provision for Possible Loss',
                        HeadingStyle: 'heading2Indent1',
                        RowStyle: 'row3',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbIncomeStatementMap: 15,
                        MySqlColumnName: 'ProfitFromRegularActivities',
                        WorkSheetColumnName: 'Profit from Regular Activities',
                        HeadingStyle: 'heading1BoldNoHighlight',
                        RowStyle: 'row2White',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbIncomeStatementMap: 16,
                        MySqlColumnName: 'ExtraordinaryIncomeAndExpenses',
                        WorkSheetColumnName: 'Extraordinary Income/Expenses (Net)',
                        HeadingStyle: 'heading2Indent1',
                        RowStyle: 'row3',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbIncomeStatementMap: 17,
                        MySqlColumnName: 'ProfitBeforeBonusAndTaxes',
                        WorkSheetColumnName: 'Profit before Bonus and Taxes',
                        HeadingStyle: 'heading1BoldNoHighlight',
                        RowStyle: 'row2White',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbIncomeStatementMap: 18,
                        MySqlColumnName: 'ProvisionForStaffBonus',
                        WorkSheetColumnName: 'Provision for Staff Bonus',
                        HeadingStyle: 'heading2Indent1',
                        RowStyle: 'row3',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbIncomeStatementMap: 19,
                        MySqlColumnName: 'ProvisionForTax',
                        WorkSheetColumnName: 'Provision for Tax',
                        HeadingStyle: 'heading2Indent1',
                        RowStyle: 'row3',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                    {
                        idcbIncomeStatementMap: 20,
                        MySqlColumnName: 'NetProfitOrLoss',
                        WorkSheetColumnName: 'Net Profit/Loss',
                        HeadingStyle: 'heading1BoldNoHighlight',
                        RowStyle: 'row2White',
                        Format: 'Regular',
                        fchartdisplaystatus: 1000,
                        annualstatus: 1,
                        quarterlystatus: 1,
                    },
                ],
            },
        },
      */
    },

    // User watchlist
    watchlistTickers: [
        /*
        'NABIL',
        'SCB',
        'SBL',
        */
    ],

    watchlist: [
        /*
        {
            ticker: 'SCB',
            lastTradedPrice: 1949,
            vol: 62905968,
            pointChange: -6,
            percentageChange: -0.3069053708439898,
            priceActions: {
                priceAction: '12 o\'clock traded amount ...',
                header: 'Falling Investor Participation',
                actionType: 'topright',
                timestamp: 1514438220000,
            },
        },
        {
            ticker: 'NABIL',
            lastTradedPrice: 1949,
            vol: 62905968,
            pointChange: -6,
            percentageChange: -0.3069053708439898,
            priceActions: {
                priceAction: '12 o\'clock traded amount ....',
                header: 'Falling Investor Participation',
                actionType: 'smile',
                timestamp: 1514438220000,
            },
        },
        {
            ticker: 'SBL',
            lastTradedPrice: 1949,
            vol: 62905968,
            pointChange: -6,
            percentageChange: -0.3069053708439898,
            priceActions: {
                priceAction: '12 o\'clock traded amount of 19.55 thousand ....',
                header: 'Falling Investor Participation',
                actionType: 'bottomright',
                timestamp: 1514438220000,
            },
        },
        */
    ],

    // METADATA

    tickerDetail: {
        /*
        CBL: {
            ticker: 'CBL',
            fullName: 'Civil Bank',
            sector: 'Development Bank',
        },
        NABIL: {
            ticker: 'NABIL',
            fullName: 'Nabil Bank',
            sector: 'Development Bank',
        },
        SIGS1: {
            ticker: 'SIGS1',
            fullName: 'Siddhartha Investment Growth Scheme-1',
            sector: 'Mutual Fund',
        },
        EBL: {
            ticker: 'EBL',
            fullName: 'Everest Bank Limited',
            sector: 'Development Bank',
        },
        SCB: {
            ticker: 'SCB',
            fullName: 'Standard Chartered Bank',
            sector: 'Development Bank',
        },
        NBIL: {
            ticker: 'NBIL',
            fullName: 'Nepal Bangladesh Investment Bank',
            sector: 'Development Bank',
        },
        SBL: {
            ticker: 'SBL',
            fullName: 'Siddartha Bank Limited',
            sector: 'Development Bank',
        },
        */
    },

    tickerDetailSector: [
        /*
        { sector: 'Commercial Banks', tickers: [] },
        { sector: 'Development Bank', tickers: ['NABIL', 'EBL', 'SCB', 'NBIL', 'SBL'] },
        { sector: 'Life Insurance', tickers: [] },
        { sector: 'Non Life Insurance', tickers: [] },
        { sector: 'Hydro Power', tickers: [] },
        { sector: 'Manufacturing And Processing', tickers: [] },
        { sector: 'Microcredit', tickers: [] },
        { sector: 'Finance', tickers: [] },
        { sector: 'Hotels', tickers: [] },
        { sector: 'Telecom', tickers: [] },
        { sector: 'Trading', tickers: [] },
        { sector: 'Mutual Fund', tickers: ['SIGS1'] },
        */
    ],

    upcomingEvents: [
        /*
        {
            id: 8603,
            ticker: 'HAMRO',
            company: 'Hamro Bikas Bank',
            details: 'SGM',
            eventType: 'SGM',
            agenda: 'Proposal for Expansion of Working Districts##Amendment of MOA and AOA',
            bookClose: 1515348900000,
            fiscalYear: 'FY 2017/18',
            shareRegistrar: 'null',
            daysToGo: 0,
        },
        {
            id: 8605,
            ticker: 'SINDU',
            company: 'Sindhu Bikash Bank',
            details: 'Right Shares Auction',
            eventType: 'Auction',
            agenda: '5,38,302.40 Units of Promotor ...',
            openDate: 1516040100000,
            closeDate: 1516731300000,
            fiscalYear: 'FY 2017/18',
            shareRegistrar: 'NIBL Capital',
            daysToGo: 7,
        },
        */
    ],

    todaysEvents: [
        /*
        {
            id: 6806,
            ticker: 'ODBL',
            company: 'Om Development Bank Ltd.',
            details: 'Right Shares Auction',
            eventType: 'Auction',
            agenda: '46,082 Units of Promotor ....',
            openDate: 1513448100000,
            closeDate: 1514052900000,
            fiscalYear: 'FY 2017/18',
            shareRegistrar: 'NIBL Capital',
        },
        {
            id: 6934,
            ticker: 'NBF1',
            company: 'Nabil Balance Fund 1',
            details: 'Monthly Financial Report -Mangsir 2074',
            eventType: 'Financials',
            agenda: 'null',
            fiscalYear: 'FY 2017/18',
            shareRegistrar: 'null',
        },
        */
    ],

    todayAnnouncements: [
        /*
        {
            id: 6942,
            ticker: 'TNBL',
            companyName: 'Tinau Development Bank',
            inputDate: 1505562287000,
            announcementType: 'Distribution',
            fiscalYear: 'FY 2016/17',
            detail: 'Dividend Distribution',
            shareRegistrar: 'Siddhartha Capital',
            openDate: 1505562287000,
            time: null,
            venue: null,
            agenda: '5% Cash Dividend Distribution',
        },
        {
            id: 6934,
            ticker: 'NBF1',
            companyName: 'Nabil Balance Fund 1',
            inputDate: 1505562287000,
            announcementType: 'Financials',
            fiscalYear: 'FY 2017/18',
            detail: 'Monthly Financial Report -Mangsir 2074',
            shareRegistrar: null,
            eventDate: 1505562287000,
            time: null,
            venue: null,
            agenda: null,
        },
        */
    ],

    movers: {
        /*
        gainers: [
            {
                ticker: 'SANIMA',
                pointChange: 1.00,
                percentageChange: 0.29,
            },
            {
                ticker: 'JSLBB',
                pointChange: 69.00,
                percentageChange: 1.85,
            },
        ],
        losers: [
            {
                ticker: 'MNBBL',
                pointChange: -16.00,
                percentageChange: 3.52,
            },
            {
                ticker: 'ODBL',
                pointChange: -1.00,
                percentageChange: 0.41,
            },
        ],
        */
    },

    // Announcement page
    announcements: {
        /*
        nepseCircular: [
            {
                id: 6440,
                ticker: 'EBL',
                inputDate: 1505562287000,
                fiscalYear: 'FY 2017/18',
                detail: 'Right Shares Listing',
                agenda: '15,712312,1231.18 unjits from Right Shares listed for trading',
                announcementType: 'NEPSE Circular',
            },
            {
                id: 6441,
                ticker: 'NABIL',
                inputDate: 1504245607000,
                fiscalYear: 'FY 2017/18',
                detail: 'Right Shares Listing',
                agenda: '15,712312,1231.18 unjits from Right Shares listed for trading',
                announcementType: 'NEPSE Circular',
            },
            {
                id: 6442,
                ticker: 'SCB',
                inputDate: 1504245607000,
                fiscalYear: 'FY 2017/18',
                detail: 'Right Shares Listing',
                agenda: '15,712312,1231.18 unjits from Right Shares listed for trading',
                announcementType: 'NEPSE Circular',
            },
        ],
        financials: [
            {
                id: 6540,
                ticker: 'SANIMA',
                inputDate: 1504245607000,
                detail: 'Right Shares Listing',
                announcementType: 'Financials',
            },
            {
                id: 6541,
                ticker: 'SCB',
                inputDate: 1508213596000,
                detail: '11th AGM',
                announcementType: 'Financials',
            },
            {
                id: 6542,
                ticker: 'NBIL',
                inputDate: 1504245607000,
                detail: 'Just some random announcement',
                announcementType: 'Financials',
            },
        ],
        ipoFpo: [
            {
                id: 6640,
                ticker: 'AB',
                companyName: 'Acid Bank',
                inputDate: 1504245607000,
                fiscalYear: 'FY 2017/18',
                detail: 'FPO',
                openDate: 1504245607000,
                closeDate: 1504245607000,
                announcementType: 'FPO',
                agenda: '15,712312,1231.18 unjits from Right Shares listed for trading',
                shareRegistrar: 'Siddhartha Capital Ltd.',
            },
            {
                id: 6641,
                ticker: 'null',
                companyName: 'Something Band',
                inputDate: 1508213596000,
                fiscalYear: 'FY 2017/18',
                detail: 'FPO',
                openDate: 1504245607000,
                closeDate: 1504245607000,
                announcementType: 'IPO',
                agenda: '15,712312,1231.18 unjits from Right Shares listed for trading',
                shareRegistrar: 'Siddhartha Capital Ltd.',
            },
            {
                id: 6642,
                companyName: 'Nabil Bank',
                inputDate: 1504245607000,
                fiscalYear: 'FY 2017/18',
                detail: 'IPO',
                openDate: 1504245607000,
                closeDate: 1504245607000,
                announcementType: 'FPO',
                agenda: '15,712312,1231.18 unjits from Right Shares listed for trading',
                shareRegistrar: 'Siddhartha Capital Ltd.',
            },
        ],
        rightShares: [
            {
                id: 6740,
                ticker: 'TGL',
                inputDate: 1504245607000,
                fiscalYear: 'FY 2017/18',
                detail: 'Right Shares Listing',
                agenda: '15,712312,1231.18 unjits from Right Shares listed for trading',
                announcementType: 'Right Shares',
                eventDate: 1504245607000,
            },
            {
                id: 6741,
                ticker: 'SCB',
                inputDate: 1508213596000,
                fiscalYear: 'FY 2017/18',
                detail: '11th AGM',
                agenda: '15,712312,1231.18 unjits from Right Shares listed for trading',
                openDate: 1504245607000,
                closeDate: 1504245607000,
                bookCloseDate: 1504245607000,
                announcementType: 'Right Shares',
                eventDate: 1504245607000,
            },
            {
                id: 6742,
                ticker: 'NBIL',
                inputDate: 1504245607000,
                fiscalYear: 'FY 2017/18',
                detail: 'Just some random announcement',
                agenda: '15,712312,1231.18 unjits from Right Shares listed for trading',
                openDate: 1504245607000,
                closeDate: 1504245607000,
                bookCloseDate: 1504245607000,
                announcementType: 'Right Shares',
                eventDate: 1504245607000,
            },
        ],
        auction: [
            {
                id: 6840,
                ticker: 'QWE',
                inputDate: 1504245607000,
                fiscalYear: 'FY 2017/18',
                detail: 'Right Shares Listing',
                openDate: 1504245607000,
                closeDate: 1504245607000,
                announcementType: 'Auction',
                allotmentDate: 1504245607000,
                shareRegistrar: 'NMB Capital Limited',
                agenda: '15,712312,1231.18 unjits from Right Shares listed for trading',
            },
            {
                id: 6841,
                ticker: 'SCB',
                inputDate: 1508213596000,
                fiscalYear: 'FY 2017/18',
                detail: '11th AGM',
                openDate: 1504245607000,
                closeDate: 1504245607000,
                announcementType: 'Auction',
                allotmentDate: 1504245607000,
                shareRegistrar: 'NMB Capital Limited',
                agenda: '15,712312,1231.18 unjits from Right Shares listed for trading',
            },
            {
                id: 6842,
                ticker: 'NBIL',
                inputDate: 1504245607000,
                fiscalYear: 'FY 2017/18',
                detail: 'Just some random announcement',
                openDate: 1504245607000,
                closeDate: 1504245607000,
                announcementType: 'Auction',
                allotmentDate: 1504245607000,
                shareRegistrar: 'NMB Capital Limited',
                agenda: '15,712312,1231.18 unjits from Right Shares listed for trading',
            },
        ],
        bondDebenture: [
            {
                id: 6435,
                companyName: 'Citizen Savings Bank',
                inputDate: 1508609700000,
                eventDate: 1508609700000,
                fiscalYear: 'FY 2017/18',
                detail: 'Development Bond',
                agenda: 'Development Bond 2081 Ka##Issue Size of NPR 6....',
                closeDate: 1508609700000,
                announcementType: 'Bond',
                shareRegistrar: 'NRB',
            },
            {
                id: 6447,
                ticker: null,
                companyName: 'Citizen Savings Bank',
                inputDate: 1508782500000,
                fiscalYear: 'FY 2017/18',
                detail: 'Citizen Savings Bond',
                agenda: 'Citizens Savings Bond 2079 Ka## Issue Size of NPR 2 Billion##Bond ...',
                openDate: 1509214500000,
                closeDate: 1510856100000,
                announcementType: 'Bond',
                shareRegistrar: 'NRB',
            },
        ],
        agmSgm: [
            {
                id: 7,
                ticker: 'SRBL',
                inputDate: 1463508900000,
                eventDate: 1464804900000,
                bookCloseDate: 1464804900000,
                fiscalYear: 'FY 2015/16',
                detail: 'SGM',
                agenda: 'Acquisition of Narayani National Finance##DDA##Scheme of Arrangement',
                announcementType: 'SGM',
                venue: 'Amrit Bhog Caterers, Kalikasthan, Dillibazar, Kathmandu',
                time: '11:00 am',
            },
            {
                id: 8,
                ticker: 'NNFC',
                inputDate: 1463508900000,
                eventDate: 1464804900000,
                bookCloseDate: 1464804900000,
                fiscalYear: 'FY 2015/16',
                detail: 'SGM',
                agenda: 'Acquisition by Sunrise Bank##DDA##Scheme of Arrangement',
                announcementType: 'SGM',
                venue: 'Lainchaur Banquet, Nepal Scout Compound, Lainchaur, Kathmandu',
                time: '11:00 am',
            },
        ],
        dividend: [
            {
                id: 2631,
                ticker: 'SANIMA',
                inputDate: 1504462500000,
                eventDate: 1504203300000,
                bookCloseDate: 1504203300000,
                fiscalYear: 'FY 2016/17',
                detail: 'Dividend Announcement',
                agenda: 'Proposal for 16% Stock Dividend to their Shareholders ...',
            },
            {
                id: 2597,
                ticker: 'DBBL',
                inputDate: 1503857700000,
                eventDate: 1503771300000,
                bookCloseDate: 1504203300000,
                fiscalYear: 'FY 2016/17',
                detail: 'Dividend Announcement',
                agenda: 'Proposal for 17.1% Stock and 0.9% Cash ...',
            },
            {
                id: 2572,
                ticker: 'NIL',
                inputDate: 1503252900000,
                eventDate: 1503252900000,
                fiscalYear: 'FY 2016/17',
                detail: 'Dividend Announcement',
                agenda: 'Proposal for 10% Stock and 0.52% Cash ...',
            },
        ],
        */
    },

    // Overview page
    overviewActiveSector: 'nepse',

    overviewTimeSeries: {},

    topGainers: [
        /*
        {
            ticker: 'EBL',
            percentageChange: 22.20,
            priceChange: 3435,
            price: 1321321,
        },
        {
            ticker: 'SBL',
            percentageChange: 1.20,
            priceChange: 455,
            price: 4123,
        },
        */
    ],

    topLosers: [
        /*
        {
            ticker: 'CHCL',
            percentageChange: -3.23,
            priceChange: -3435,
            price: 1321,
        },
        {
            ticker: 'SHINE',
            percentageChange: -1.20,
            priceChange: -453,
            price: 4123,
        },
        */
    ],

    highestTurnover: [
        /*
        {
            ticker: 'EBL',
            value: 12312312,
        },
        {
            ticker: 'SBNL',
            value: 446456456,
        },
        */
    ],

    mostActive: [
        /*
        {
            ticker: 'SBL',
            value: 734343,
        },
        {
            ticker: 'NABIL',
            value: 234343,
        },
        */
    ],

    topBrokers: [
        /*
        {
            brokerNumber: 23,
            amount: 1265634,
            topBuy: 'NHPC',
            topSell: 'SBL',
        },
        {
            brokerNumber: 2,
            amount: 743453,
            topBuy: 'CHCL',
            topSell: 'SBNL',
        },
        */
    ],

    sectors: {
        /*
        nepse: {
            currentValue: 1472.15,
            pc: -0.83,
            pointChange: 12.32,
            volume: 447976000.00,
            advances: 27,
            declines: 106,
        },
        sensitive: {},
        float: {},
        senFloat: {},
        banking: {},
        devBank: {},
        hydropower: {},
        insurance: {},
        others: {},
        */
    },

    // Market page
    marketNotifications: [
        /*
        {
            ticker: 'NEPSE',
            header: 'Nepse Circular',
            priceAction: 'Nulla facilisi. Ut maximus nec libero eget aliquet. ...',
            actionType: 'alert',
            timestamp: 1501867165000,
        },
        {
            ticker: 'NIBL',
            header: 'Trend Reversal',
            priceAction: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. ...',
            actionType: 'mike',
            timestamp: 15010478345000,
        },
        {
            ticker: 'SBI',
            header: 'Open Gap Up',
            priceAction: 'Lorem Ipsum sit Dolor Amet',
            actionType: 'up',
            timestamp: 15455165000,
        },
        {
            ticker: 'SBL',
            header: 'Trend Reversal',
            priceAction: 'Suspendisse lobortis fermentum fermentum. Aliquam ...',
            actionType: 'sideways',
            timestamp: 151125165000,
        },
        {
            ticker: 'NABIL',
            header: 'Trend Reversal',
            priceAction: 'Suspendisse lobortis fermentum fermentum. ...',
            actionType: 'down',
            timestamp: 150127365000,
        },
        */
    ],

    priceActions: {
        /*
        NABIL: [
            {
                ticker: 'NABIL',
                header: 'Nepse Circular',
                body: 'Nulla facilisi. Ut maximus nec libero eget aliquet. ....',
                actionType: 'alert',
                timestamp: 1511867165000,
            },
            {
                ticker: 'NABIL',
                header: 'Trend Reversal',
                body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. ...',
                actionType: 'mike',
                timestamp: 15210478345100,
            },
            {
                ticker: 'NABIL',
                header: 'Open Gap Up',
                body: 'Lorem Ipsum sit Dolor Amet',
                actionType: 'up',
                timestamp: 153475165020,
            },
            {
                ticker: 'NABIL',
                header: 'Trend Reversal',
                body: 'Suspendisse lobortis fermentum fermentum. Aliquam hendrerit ...',
                actionType: 'sideways',
                timestamp: 155125165004,
            },
            {
                ticker: 'NABIL',
                header: 'Trend Reversal',
                body: 'Suspendisse lobortis fermentum fermentum. ...',
                actionType: 'down',
                timestamp: 120123365036,
            },
            {
                ticker: 'NABIL',
                header: 'Trend Reversal',
                body: 'Suspendisse lobortis fermentum fermentum. Aliquam ...',
                actionType: 'sideways',
                timestamp: 250123365008,
            },
        ],
        */
    },

    comparativeActiveViewId: 1,

    comparativeView: {
        /*
        1: {
            securities: ['NABIL', 'SCB', 'EBL', 'NBIL', 'SANIMA', 'NTC', 'CZBIL', 'API',
                'ARUN', 'AVU', 'BARUN', 'BBC', 'GMFIL', 'JEFL', 'JFL', 'JBBL', 'KMFL',
                'HIDCL', 'ICFC', 'HDL', 'LBL', 'LFC', 'MFIL',
                'MIDBL', 'MERO', 'NLG', 'NLICL', 'SBI', 'SICL',
                'HPPL'],
            criteria: ['price__oneWeekPriceChange'],
            pristine: false,
        },
        2: {
            securities: ['NABIL', 'SCB'], // bulk change
            criteria: ['price__oneWeekPriceChange', 'valuationMultiples__epsF'], // bulk change
            pristine: false,
        },
        3: {
            securities: ['NABIL', 'SCB', 'EBL', 'NBIL'], // bulk change
            criteria: ['valuationMultiples__epsD', 'valuationMultiples__epsF'], // bulk change
            pristine: false,
        },
        */
    },

    comparativeData: {
        /*
        1: {
            NABIL: {
                ticker: 'NABIL',

                price__latestClose: 1513,
                price__OneEightyDayAverage: 1572.6296,
                price__todaysChange: -12,
                price__oneWeekPriceChange: -0.0301,
                price__fourWeekPriceChange: -0.0332,
                price__twelveWeekPriceChange: -0.0774,
                price__oneYearPriceChange: 0.1371,
                price__ytdChange: 0.4689,

                measureOfSize__MarketCap: 7611333.2042,
                measureOfSize__paidUpCapital: 503062.34,
                measureOfSize__reservesAndSurplus: 1111010.08,
                measureOfSize__totalRevenue: 1090084.04,
                measureOfSize__grossProfit: 638278.59,
                measureOfSize__netIncome: 330667.08,

                margins__grossMarginMrq: 0.518462,
                margins__sgaMarginMrq: 0.102064,
                margins__ebitdaMarginMrq: 0,
                margins__ebitdMarginMrq: 0.416442,
                margins__netProfitMarginMrq: 0.267585,
                margins__grossMarginTtm: 0.585532,
                margins__sgaMarginTtm: 0.111037,
                margins__ebitdaMarginTtm: 0,
                margins__ebitMarginTtm: 0.475425,
                margins__netProfitMarginTtm: 0.303341,

                managementEffectiveness__roeF: 0.209556,
                managementEffectiveness__roeMrq: 0.228958,
                managementEffectiveness__roeTtm: 0.225494,
                managementEffectiveness__roaF: 0.022607,
                managementEffectiveness__roaMrq: 0.0247,
                managementEffectiveness__roaTtm: 0.024701,

                valuationMultiples__epsF: 65.730836,
                valuationMultiples__epsMrq: 71.816682,
                valuationMultiples__epsTtm: 65.730836,
                valuationMultiples__epsD: 65.730836,
                valuationMultiples__bvp: 320.849384,
                valuationMultiples__peD: 23.018116,
                valuationMultiples__peF: 23.018116,
                valuationMultiples__peMrq: 21.067529,
                valuationMultiples__peTtm: 23.018116,
                valuationMultiples__pbv: 4.715608,

                liquidityAndSolvency__currentRatio: 0.047333,
                liquidityAndSolvency__quickRatio: 0,
                liquidityAndSolvency__totalLiabilities: 0.891975,
                liquidityAndSolvency__quityMultiplier: 9.257115,

                growthRate_netIncomeOverPriorPeriod: 0.097897,
                growthRate_netIncomeYoy: 0.446795,

                risk__betaWeekly: 1.3264,
                risk__betaMonthly: 1.5561,
                risk__var1WeekAt5: -0.0209,
                risk__var1WeekAt1: -0.0302,
                risk__var1MonthAt5: -0.16,
                risk__var1MonthAt1: -0.2441,

                technicalIndicators__rsi: 39.1276,
                technicalIndicators__macdCrossover: -0.972769,
                technicalIndicators__relativeStrength: -0.019246,
                technicalIndicators__FiftyDayMAVsTwoHundreadDayMA: 0.156,
                technicalIndicators__PriceVsFiftyTwoWeekHigh: -0.1254,
            },
        },
        */
    },
};

export default initialState;



// WEBPACK FOOTER //
// ./src/common/initial-state/domainData.js